var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_content",staticStyle:{"padding":"0"},attrs:{"id":"pro_block"}},[_c('project-list',{attrs:{"data":_vm.proList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }